// extracted by mini-css-extract-plugin
export default {"container":"_1FO5dOO"};